var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTelegram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 25,
    viewBox: "0 0 30 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.2552 23.952C25.1621 24.1728 25.0206 24.3722 24.8399 24.5367C24.6593 24.7012 24.4438 24.8271 24.2079 24.9059C23.972 24.9847 23.7212 25.0145 23.4721 24.9935C23.2231 24.9724 22.9817 24.9009 22.7641 24.7838L16.015 19.792L11.6833 23.5959C11.5828 23.6666 11.4653 23.7121 11.3414 23.7282C11.2176 23.7443 11.0915 23.7305 10.9748 23.688L11.8052 16.616L11.8317 16.636L11.8487 16.4964C11.8487 16.4964 23.9936 5.97157 24.4883 5.52315C24.9892 5.07589 24.8239 4.97887 24.8239 4.97887C24.8525 4.43333 23.9251 4.97887 23.9251 4.97887L7.83348 14.8329L1.13209 12.6605C1.13209 12.6605 0.10282 12.3091 0.00585967 11.5364C-0.0960725 10.7697 1.16562 10.3532 1.16562 10.3532L27.8097 0.27797C27.8097 0.27797 30 -0.650912 30 0.887357L25.2552 23.952Z",
    fill: "#585F71"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.56164bcc.svg";
export { ForwardRef as ReactComponent };